import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { CheckCircle, ArrowRight, Loader2 } from 'lucide-react';

// Production-safe API host: same-origin in deployed builds, env var in preview.
const _ENV_BACKEND = process.env.REACT_APP_BACKEND_URL || '';
const _ORIGIN = typeof window !== 'undefined' ? window.location.origin : '';
const _isPreviewEnv = /preview\.emergentagent\.com$/.test(
  (typeof window !== 'undefined' && window.location.hostname) || ''
);
const API = _isPreviewEnv ? _ENV_BACKEND : (_ORIGIN || _ENV_BACKEND);

const MembershipSuccess = () => {
  const [params] = useSearchParams();
  const sessionId = params.get('session_id');
  const [attempts, setAttempts] = useState(0);
  const [status, setStatus] = useState(null);
  const [done, setDone] = useState(false);

  useEffect(() => {
    if (!sessionId) return;
    if (done) return;
    if (attempts >= 6) { setDone(true); return; }

    const poll = async () => {
      try {
        const r = await fetch(`${API}/api/membership/status-by-session/${sessionId}`);
        const data = await r.json();
        setStatus(data);
        if (data?.is_member) { setDone(true); return; }
      } catch { /* ignore */ }
      setTimeout(() => setAttempts((a) => a + 1), 2000);
    };
    poll();
  }, [sessionId, attempts, done]);

  return (
    <div style={{ minHeight: '100vh', background: '#0f172a', color: '#e2e8f0', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
      <div style={{ maxWidth: 560, textAlign: 'center', background: 'rgba(255,255,255,0.04)', padding: 40, borderRadius: 14 }}>
        {status?.is_member ? (
          <>
            <CheckCircle size={56} color="#34d399" />
            <h1 data-testid="membership-success-title" style={{ fontSize: '1.8rem', color: '#f8fafc', marginTop: 16 }}>Welcome to the Association!</h1>
            <p style={{ color: '#cbd5e1', marginTop: 12 }}>Your $9.99/month membership is now active. Member # <strong style={{ color: '#5eead4' }}>{status.member_number}</strong>.</p>
            <Link to="/membership/dashboard" data-testid="go-to-member-dashboard" style={{ display: 'inline-flex', alignItems: 'center', gap: 8, padding: '14px 28px', borderRadius: 999, background: 'linear-gradient(90deg,#14b8a6,#0d9488)', color: 'white', fontWeight: 700, textDecoration: 'none', marginTop: 24 }}>
              Open Member Dashboard <ArrowRight size={18} />
            </Link>
          </>
        ) : (
          <>
            <Loader2 size={48} color="#5eead4" style={{ animation: 'spin 1s linear infinite' }} />
            <h1 style={{ fontSize: '1.5rem', color: '#f8fafc', marginTop: 16 }}>Activating your membership…</h1>
            <p style={{ color: '#94a3b8', marginTop: 10 }}>Stripe is confirming your subscription. This usually takes a few seconds.</p>
            {attempts >= 5 && (
              <p style={{ color: '#fca5a5', marginTop: 16, fontSize: '0.85rem' }}>Taking longer than expected. Refresh in a moment, or check your email — the membership will be active once Stripe finishes processing.</p>
            )}
          </>
        )}
        <style>{`@keyframes spin{from{transform:rotate(0)}to{transform:rotate(360deg)}}`}</style>
      </div>
    </div>
  );
};

export default MembershipSuccess;
